import react from "react";

import bash1 from "../images/commercials/BASH/19_BASH_09 Large.jpeg";
import bash2 from "../images/commercials/BASH/23_BASH_01 Large.jpeg";

const Bash = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={bash1} alt="Bash Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={bash2} alt="Bash Commercial Photography - Image 2"/>
                </div>
            </div>
        </div>
    );
}

export default Bash;